import { BaSeTheme } from '@base/react';
import styled from 'styled-components';

const handleQuery = (style) => {
  return `
    ${BaSeTheme.breakpoints.mobileLarge.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobile.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobileSmall.mediaQueryCss(style)};
  `;
};

export const Container = styled.div`
  height: 100%;
  width: 100%;
  padding: 0 20px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  gap: 12px;
`;

export const ContentStepper = styled.div`
  max-width: 560px;
  margin-top: 24px;
`;

export const AlignDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 18px 0 20px 0;
  gap: 12px;
`;

export const AligiPageInformations = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22px;
`;

export const Content = styled.div`
  padding: 16px 24px;
  position: relative;
  background: ${BaSeTheme.colors.defaultColors.white};
  border: 1px solid ${BaSeTheme.colors.institucionais.cinzaSebrae90};
  box-shadow: 0px 32px 30px rgba(20, 46, 82, 0.2);
  border-radius: 4px;
  ${handleQuery(`
    width: 90%;
  `)}
`;

export const AlignOptions = styled.div`
  display: flex;
  flex-direction: ${({ sequenceStep }) =>
    sequenceStep === 8 ? 'column' : 'row'};
  gap: 8px;
  margin-top: 4px;
  flex-wrap: wrap;
`;

export const ContentOptions = styled.div`
  margin-bottom: 24px;
`;
